import React, { useState, useRef, useEffect, useContext } from "react";
import { Modal, Button } from "rsuite";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes, faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { BrandColorContext } from "../../../App";
import { useTranslation } from "react-i18next";

const ViewMoreText = ({ rate, text, initialLines = 2 }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const textRef = useRef(null);
  const brandColor = useContext(BrandColorContext);
  useEffect(() => {
    const element = textRef.current;
    if (element) {
      if (element.scrollHeight > element.clientHeight) {
        setIsOverflowing(true);
      }
    }
  }, [rate.rateCancellationPolicies]);

  const handleOpen = (e) => {
    e.preventDefault();
    setOpen(true);
  };
  const handleClose = () => setOpen(false);

  const style = {
    display: "-webkit-box",
    WebkitLineClamp: initialLines,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    textOverflow: "ellipsis",
  };

  return (
    <>
      <style>{`
        .rs-modal-header .rs-modal-header-close { 
          display: none;
        }
          .rs-modal-content{
          padding: 0 !important;
          }
      `}</style>
      <div>
        <div className="d-flex items-top">
          <ul className="list-disc text-10 mt-1" ref={textRef} style={style}>
            {rate.rateCancellationPolicies?.map((c, idx) => (
              <li className="policy" key={idx}>
                {c}
              </li>
            ))}
          </ul>
        </div>

        <Modal
          open={open}
          onClose={handleClose}
          size="md"
          style={{
            zIndex: 10000,
          }}
          backdrop={true}
        >
          <Modal.Header
            style={{
              borderBottom: `2px solid ${brandColor}`,
              padding: "20px 30px",
              background: brandColor,
              color: "white",
              borderRadius: "8px 8px 0 0",
              margin: 0,
            }}
          >
            <div className="d-flex items-center justify-content-between w-100">
              <div className="d-flex items-center">
                <FontAwesomeIcon
                  icon={faInfoCircle}
                  className="me-2"
                  style={{ fontSize: "20px" }}
                />
                <Modal.Title
                  style={{
                    color: "white",
                    fontSize: "20px",
                    fontWeight: "600",
                    margin: 0,
                  }}
                >
                  {t("common.cancellationPolicies")}
                </Modal.Title>
              </div>
              <button
                onClick={handleClose}
                style={{
                  background: "rgba(255, 255, 255, 0.2)",
                  border: "none",
                  borderRadius: "50%",
                  width: "32px",
                  height: "32px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  color: "white",
                  transition: "all 0.3s ease",
                  flexShrink: 0,
                }}
                onMouseEnter={(e) => {
                  e.target.style.background = "rgba(255, 255, 255, 0.3)";
                  e.target.style.transform = "rotate(90deg)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = "rgba(255, 255, 255, 0.2)";
                  e.target.style.transform = "rotate(0deg)";
                }}
              >
                <FontAwesomeIcon icon={faTimes} />
              </button>
            </div>
          </Modal.Header>
          <Modal.Body
            style={{
              padding: "25px 30px",
              maxHeight: "60vh",
              overflowY: "auto",
              margin: 0,
            }}
          >
            <div
              style={{
                background: "#f8f9fa",
                padding: "20px",
                borderRadius: "8px",
                border: `1px solid ${brandColor}20`,
              }}
            >
              <ul
                className="list-disc"
                style={{
                  margin: 0,
                  paddingLeft: "20px",
                  listStyleType: "disc",
                }}
              >
                {rate.rateCancellationPolicies?.map((c, idx) => (
                  <li
                    className="policy mb-3"
                    key={idx}
                    style={{
                      fontSize: "14px",
                      lineHeight: "1.6",
                      color: "#333",
                      paddingLeft: "25px",
                    }}
                  >
                    {c}
                  </li>
                ))}
              </ul>
            </div>
          </Modal.Body>
          <Modal.Footer
            style={{
              borderTop: "1px solid #e5e5e5",
              padding: "15px 30px",
              display: "flex",
              justifyContent: "flex-end",
              margin: 0,
            }}
          >
            <Button
              onClick={handleClose}
              appearance="primary"
              style={{
                background: brandColor,
                border: "none",
                padding: "10px 30px",
                borderRadius: "6px",
                fontWeight: "500",
                transition: "all 0.3s ease",
                color: "white",
              }}
              onMouseEnter={(e) => {
                e.target.style.transform = "translateY(-2px)";
                e.target.style.boxShadow = `0 4px 12px ${brandColor}40`;
                e.target.style.opacity = "0.9";
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = "translateY(0)";
                e.target.style.boxShadow = "none";
                e.target.style.opacity = "1";
              }}
            >
              {t("common.close")}
            </Button>
          </Modal.Footer>
        </Modal>

        {isOverflowing && (
          <button
            type="button"
            onClick={handleOpen}
            className="d-block text-10 text-center mx-auto underline fw-500 mt-5"
            style={{
              background: "transparent",
              border: "none",
              cursor: "pointer",
              transition: "all 0.3s ease",
              color: brandColor,
              textDecoration: "underline",
            }}
            onMouseEnter={(e) => {
              e.target.style.opacity = "0.8";
              e.target.style.textDecoration = "underline";
            }}
            onMouseLeave={(e) => {
              e.target.style.opacity = "1";
              e.target.style.textDecoration = "underline";
            }}
          >
            {t("common.cancellationPolicy")}
          </button>
        )}
      </div>
    </>
  );
};

export default ViewMoreText;
